<template>
    <div class="pt__tab">
        <p
            v-for="tab in config"
            :key="tab.action"
            :class="['pt__tab-item', {
                'pt__tab-item--active': tab.action === value,
                'pt__tab-item--disabled': tab.disabled
            }]"
            :style="{ backgroundColor: tab.action === value ? activeColor : '' }"
            @click="toggleTab(tab)"
        >
            <slot :context="tab">
                <span class="pt__tab-item-text">{{ $t(tab.label) }}</span>
            </slot>
            <span class="pt__tab-item-bottom-line" :style="{ backgroundColor: activeColor }" />
        </p>
    </div>
</template>

<script>
export default {
    name: 'PtTabs',
    props: {
        value: {
            type: String,
            required: true,
        },
        config: {
            type: Array,
            required: true,
        },
        activeColor: {
            type: String,
            required: false,
            default: '#fff',
        },
    },
    methods: {
        toggleTab(tabInfo) {
            const { action, disabled } = tabInfo;
            if (disabled) return;
            if (action === this.value) return;
            this.$emit('input', action);
            this.$emit('tab-click', action);
        },
    },
};
</script>

<style lang="scss" scoped>
.pt__tab {
    border-bottom: 1px solid $neutral-blue-60;
    &::after {
        content: '.';
        display: block;
        height: 0;
        visibility: hidden;
        clear: both;
    }
    .pt__tab-item {
        display: inline-block;
        background-color: $neutral-blue-40;
        color: $neutral-blue-300;
        border-radius: 4px 4px 0 0;
        height: 32px;
        line-height: 32px;
        min-width: 94px;
        text-align: center;
        padding: 0 16px;
        cursor: pointer;
        border: 1px solid $neutral-blue-40;
        position: relative;
        margin-right: 4px;
        float: left;
        &:last-of-type {
            margin-right: 0;
        }
        &:hover {
            background-color: $neutral-blue-30;
            border-color: $neutral-blue-30;
        }
        &--active {
            border-color: $neutral-blue-60 !important;
            color: $neutral-blue-1000;
            .pt__tab-item-bottom-line {
                display: block;
            }
        }
    }
    .pt__tab-item-bottom-line {
        height: 2px;
        width: 100%;
        background-color: #fff;
        position: absolute;
        bottom: -2px;
        left: 0;
        display: none;
    }
}
</style>
